import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MadCapImageUrlModule } from '@portal-core/general/pipes/madcap-image-url/madcap-image-url.module';
import { InlineButtonModule } from '@portal-core/ui/button/components/inline-button/inline-button.module';
import { LicenseAvatarComponent } from './license-avatar.component';

@NgModule({
  declarations: [
    LicenseAvatarComponent
  ],
  imports: [
    CommonModule,
    InlineButtonModule,
    MadCapImageUrlModule,
    MatDialogModule,
    MatTooltipModule
  ],
  exports: [
    LicenseAvatarComponent
  ]
})
export class LicenseAvatarModule { }
